// extracted by css-extract-rspack-plugin
export default {"label":"label-1QRjw"};